import DeletePassengersOverview from './DeletePassengersOverview'

export default DeletePassengersOverview
